import { StaffApiService } from '@common/ApiService'
const ROLES_SUCCESS = 'ROLES_SUCCESS'
const ROLE_ERROR = 'ORGANISATION_ERROR'
const ROLE_SUCCESS = 'ROLE_SUCCESS'
const ROLES_CLEAR = 'ROLES_CLEAR'

export const state = {
  roles: [],
  role: {},
  errors: {},
}

export const getters = {}

export const mutations = {
  [ROLES_SUCCESS](state, data) {
    state.roles = data
    return state
  },

  [ROLE_SUCCESS](state, data) {
    state.role = data
    return state
  },

  [ROLES_CLEAR](state) {
    state.roles = []
    return state
  },

  [ROLE_ERROR](state, data) {
    state.errors = data
    state.progress = 'error'
    return state
  },
}

export const actions = {
  createRole({ commit }, newRole) {
    return new Promise((resolve) => {
      return StaffApiService.post('v1/roles', {
        ...newRole,
      }).then((response) => {
        commit(ROLE_SUCCESS, response.data)
        resolve(response.data)
      })
    })
  },

  deleteRole({ commit }, id) {
    return StaffApiService.delete(`v1/roles/${id}`)
      .then((response) => {
        commit(ROLE_SUCCESS, response.data)
      })
      .catch((error) => commit(ROLE_ERROR, error))
  },

  updateRole({ commit }, updateObject) {
    return StaffApiService.patch(`v1/roles/${updateObject.id}`, {
      ...updateObject.role,
    }).then((response) => {
      commit(ROLE_SUCCESS, response.data)
    })
  },

  fetchRoles({ commit }, query) {
    return StaffApiService.get('v1/roles', '', {
      params: {
        by_organisation: query,
      },
    })
      .then((response) => {
        commit(ROLES_SUCCESS, response.data)
      })
      .catch((error) => commit(ROLE_ERROR, error))
  },

  fetchRole({ commit }, id) {
    return StaffApiService.get(`v1/roles/${id}`)
      .then((response) => {
        commit(ROLE_SUCCESS, response.data)
      })
      .catch((error) => commit(ROLE_ERROR, error))
  },

  clearRoles({ commit }) {
    commit(ROLES_CLEAR)
  },
}
